const collections = [
  { title: '本周热门', tag: 'HOT', tagColor: 'bg-accent-500', desc: '大家都在追的人气作品', icon: 'ri-fire-line' },
  { title: '新作上线', tag: 'NEW', tagColor: 'bg-primary-500', desc: '最新上架的漫画力作', icon: 'ri-sparkling-line' },
  { title: '完结佳作', tag: '完结', tagColor: 'bg-secondary-500', desc: '一口气读完的完整作品', icon: 'ri-check-double-line' },
  { title: '独家连载', tag: '独家', tagColor: 'bg-accent-500', desc: '酷看独家的连载漫画', icon: 'ri-star-line' },
  { title: '韩漫专区', tag: '韩漫', tagColor: 'bg-primary-500', desc: '高人气韩国漫画精选', icon: 'ri-global-line' },
  { title: '日漫经典', tag: '日漫', tagColor: 'bg-secondary-500', desc: '经典日本漫画名作', icon: 'ri-sun-line' },
  { title: '国漫原创', tag: '国漫', tagColor: 'bg-accent-500', desc: '国产原创漫画集结', icon: 'ri-flag-line' },
  { title: '分类大全', tag: '全部', tagColor: 'bg-primary-500', desc: '按类型浏览所有漫画', icon: 'ri-grid-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">专题合集</h2>
          <p className="text-sm text-foreground-500">精选分类专题，快速找到你想看的漫画</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {collections.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-50 hover:bg-primary-50/60 transition-colors cursor-pointer no-underline"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100/80 text-primary-600 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-base font-bold text-foreground-800 whitespace-nowrap">{item.title}</h3>
                  <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-bold text-background-50 ${item.tagColor} whitespace-nowrap`}>{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}